import React from "react";
import { EqualContentsRow } from "./EqualContentsRow";
import { TickBox } from "./TickBox";

export const DataPropertyRow = ({
  title,
  id,
  data,
  options,
  titleStyle,
  otherValId,
  otherFlexGrow,
  otherPostText,
  titlePostComp,
  otherPostComp,
  fontSizeOverride
}) => {
  let titleInlineStyle = { fontWeight: 600, flexGrow: 2 };
  titleStyle && (titleInlineStyle = { ...titleInlineStyle, ...titleStyle });
  return (
    <EqualContentsRow fontSizeOverride={fontSizeOverride}>
      <div style={titleInlineStyle}>
        <span style={{ paddingRight: "10px" }}>{title}</span>
        {titlePostComp}
      </div>
      {options.map((val) => {
        const isOther = val.toLowerCase() === "other";
        return val === "" ? (
          <div></div>
        ) : (
          <TickBox
            flag={data[id] === val}
            label={val}
            otherVal={data[otherValId] ? `${data[otherValId]}${otherPostText ? otherPostText : ""}` : null}
            valAreaPostText={isOther && otherPostComp ? otherPostComp : ""}
            style={isOther && otherFlexGrow ? { flexGrow: otherFlexGrow } : {}}
          />
        );
      })}
    </EqualContentsRow>
  );
};



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/DataPropertyRow.jsx